import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogService } from '../../services/blogService';
import './Blog.css';
import SEO from '../../components/SEO/SEO';


const Blog = () => {
    const [blogPosts, setBlogPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                // Fetch from Supabase
                const response = await blogService.getAllPosts();

                if (response.success && response.data.length > 0) {
                    // Convert Supabase format to match existing format
                    const supabasePosts = response.data.map(post => ({
                        id: post.id,
                        slug: post.slug,
                        title: post.title,
                        excerpt: post.excerpt,
                        category: post.category,
                        author: post.author,
                        date: post.date,
                        image: post.hero_image,
                        heroImage: post.hero_image,
                        tags: post.tags
                    }));

                    // Sort by date (newest first)
                    supabasePosts.sort((a, b) => {
                        const dateA = new Date(b.date);
                        const dateB = new Date(a.date);
                        return dateA - dateB;
                    });

                    setBlogPosts(supabasePosts);
                } else {
                    setBlogPosts([]);
                }
            } catch (error) {
                console.error('Error loading blog posts:', error);
                setBlogPosts([]);
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    return (
        <div className="blog-page">
            <SEO
                title="Blog & Insights"
                description="Read the latest digital marketing insights, strategies, and industry news from the experts at Digi Network."
                canonical="/blog"
            />
            {/* Hero Section */}
            <section className="blog-hero">
                <div className="container">
                    <div className="blog-hero-content">
                        <h1>Digital Marketing Insights</h1>
                        <p>Expert strategies, tips, and industry insights to grow your business</p>
                    </div>
                </div>
            </section>

            {/* Blog Posts Grid */}
            <section className="blog-posts-section">
                <div className="container">
                    {loading ? (
                        <div className="loading-state">
                            <h2>Loading posts...</h2>
                        </div>
                    ) : blogPosts.length === 0 ? (
                        <div className="empty-state">
                            <h2>No blog posts yet</h2>
                            <p>Check back soon for fresh insights and digital marketing strategies!</p>
                        </div>
                    ) : (
                        <div className="blog-posts-grid">
                            {blogPosts.map((post) => (
                                <Link to={`/blog/${post.slug}`} key={post.id} className="blog-card">
                                    <div className="blog-card-image">
                                        {post.heroImage || post.image ? (
                                            <img src={post.heroImage || post.image} alt={post.title} className="blog-card-img" />
                                        ) : (
                                            <div className="blog-card-image-placeholder">
                                                {post.category}
                                            </div>
                                        )}
                                        <div className="blog-category-tag">{post.category}</div>
                                    </div>
                                    <div className="blog-card-content">
                                        <h2>{post.title}</h2>
                                        <p className="blog-excerpt">{post.excerpt}</p>
                                        <div className="blog-meta">
                                            <div className="blog-author">
                                                <div className="author-avatar">{post.author.charAt(0)}</div>
                                                <span>{post.author}</span>
                                            </div>
                                            <div className="blog-info">
                                                <span className="blog-date">{post.date}</span>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            </section>

            {/* CTA Section */}
            <section className="blog-cta">
                <div className="container">
                    <h2>Ready to Transform Your Digital Presence?</h2>
                    <p>Let's discuss how our digital marketing services can help you achieve your business goals.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Get Started
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white" />
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Blog;
